import { render } from "./CatObjetoForm.vue?vue&type=template&id=2b1d8754&scoped=true"
import script from "./CatObjetoForm.vue?vue&type=script&lang=js"
export * from "./CatObjetoForm.vue?vue&type=script&lang=js"

import "./CatObjetoForm.vue?vue&type=style&index=0&id=2b1d8754&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b1d8754"]])

export default __exports__